import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import JumpDown from '../jump-down'

export default function StudentViewToggle(props) {
  const [student, setStudent] = useState(false)
  const [words, setWords] = useState("Switch to Student View")
  const msgNotAvailable = "This page is not available in Student View"

  const setToStudentView = () => {
    const teacher_accordion_columns = document.getElementsByName('teacher-accordion-column')
    const student_accordion_column = document.getElementById('student-accordion-column')
    const student_accordion_header = document.getElementById('student-accordion-header')
    const student_accordion_content = document.getElementById('collapse-Student View')

    if (!student_accordion_header) {
      alert(msgNotAvailable)
      return
    }

    student_accordion_header.setAttribute('data-view', 'student');

    if (student_accordion_header.classList.contains('closed')) {
      student_accordion_header.classList.add('open')
      student_accordion_header.classList.remove('closed')
      student_accordion_content.classList.add('show')
      student_accordion_content.classList.remove('hidden')
      props.setStudentAccordionState(true)
    }

    for (let i = 0; i < teacher_accordion_columns.length; i++) {
      teacher_accordion_columns[i].style.display = 'none'
    }

    student_accordion_column.classList.remove('col-lg-6')

    setStudent(true)
    setWords("Switch to Teacher View")
  }

  const setToTeacherView = () => {
    const teacher_accordion_columns = document.getElementsByName('teacher-accordion-column')
    const student_accordion_column = document.getElementById('student-accordion-column')
    const student_accordion_header = document.getElementById('student-accordion-header')

    if (!student_accordion_header) {
      alert(msgNotAvailable)
      return
    }

    student_accordion_header.setAttribute('data-view', 'teacher');

    for (let i = 0; i < teacher_accordion_columns.length; i++) {
      teacher_accordion_columns[i].style.display = 'block'
    }

    student_accordion_column.classList.add('col-lg-6')

    setStudent(false)
    setWords("Switch to Student View")
  }

  const toggleView = (e) => {
    e.preventDefault()

    student === true
      ? setToTeacherView()
      : setToStudentView()
  }

  return (
    <React.Fragment>
      <hr className="d-flex d-lg-none mt-5 w-100" />
      <Col xs={12} className="d-flex d-lg-none justify-content-center">
        <Button
          variant="primary"
          size="sm"
          className="p-2 mr-2"
          onClick={toggleView}
        >
          {words}
        </Button>
        <JumpDown target_id="main-content" className="p-2 ml-2" size="sm">
          Jump to Content&nbsp;<i className="fa fa-arrow-down"></i>
        </JumpDown>
      </Col>
      <hr className="d-flex d-lg-none w-100" />
      <Col xs={12} className="d-none d-lg-flex justify-content-end">
        <Button
          variant="primary"
          size="sm"
          className="p-2"
          onClick={toggleView}
        >
          {words}
        </Button>
      </Col>
    </React.Fragment>
  )
}

StudentViewToggle.propTypes = {
  setStudentAccordionState: PropTypes.func.isRequired
}